import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MessageCircle, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PublicPage } from "@/components/PublicPage";
import { FAQ, GUIDES, NOT_YET_AVAILABLE, POLICY_LINKS, searchFaq } from "@/lib/help";
import { BUSINESS, waLink } from "@/lib/site";

export default function Help() {
  const [query, setQuery] = useState("");
  const items = searchFaq(query);
  const { hash } = useLocation();
  const openId = hash.startsWith("#panduan-") ? hash.slice("#panduan-".length) : "";
  useEffect(() => { if (openId) document.getElementById(`panduan-${openId}`)?.scrollIntoView?.({ block: "start" }); }, [openId]);
  return (
    <PublicPage testid="help-page" overline="Bantuan" title="Pusat Bantuan">
      <section className="mb-8" aria-labelledby="guides-title" data-testid="guides">
        <h2 id="guides-title" className="font-heading text-lg font-semibold text-slate-900">Panduan langkah demi langkah</h2>
        <div className="mt-3 space-y-2">
          {GUIDES.map((g) => (
            <details key={g.id} id={`panduan-${g.id}`} open={openId === g.id || undefined} className="rounded-lg border border-slate-200 bg-white p-4" data-testid={`guide-${g.id}`}>
              <summary className="cursor-pointer text-sm font-medium text-slate-900">{g.title}</summary>
              <p className="mt-2 text-sm text-slate-600">{g.intro}</p>
              <ol className="mt-3 list-decimal space-y-1.5 pl-5 text-sm text-slate-700">{g.steps.map((s) => <li key={s}>{s}</li>)}</ol>
              <p className="mt-3 rounded-md bg-amber-50 p-3 text-sm text-amber-800" data-testid={`guide-failed-${g.id}`}><span className="font-medium">Jika ada masalah:</span> {g.ifFailed}</p>
              <Link to={g.path} className="mt-3 inline-block text-sm font-medium text-blue-700 hover:underline">{g.cta}</Link>
            </details>
          ))}
        </div>
        <p className="mt-3 text-sm text-slate-600" data-testid="guides-not-available">Belum tersedia (belum ada panduan karena belum bisa dipakai): {NOT_YET_AVAILABLE.join(", ")}.</p>
      </section>
      <h2 className="mb-3 font-heading text-lg font-semibold text-slate-900">Pertanyaan umum</h2>
      <div className="relative">
        <Search className="pointer-events-none absolute left-3 top-3 h-4 w-4 text-slate-400" />
        <input type="search" value={query} onChange={(e) => setQuery(e.target.value)} maxLength={100} placeholder="Cari pertanyaan…" aria-label="Cari pertanyaan"
               className="w-full rounded-md border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm" data-testid="help-search" />
      </div>
      <div className="mt-4 space-y-2" data-testid="help-list">
        {items.length === 0 && <p className="text-sm text-slate-500" data-testid="help-empty">Tidak ada pertanyaan yang cocok. Hubungi kami lewat WhatsApp di bawah.</p>}
        {items.map((f) => (
          <details key={f.id} className="rounded-lg border border-slate-200 bg-white p-4" data-testid={`faq-${f.id}`}>
            <summary className="cursor-pointer text-sm font-medium text-slate-900">{f.q}</summary>
            <p className="mt-2 text-sm text-slate-600">{f.a}</p>
          </details>
        ))}
      </div>
      <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-5">
        <p className="font-medium text-slate-900">Masih butuh bantuan?</p>
        <p className="mt-1 text-sm text-slate-600">WhatsApp {BUSINESS.whatsappDisplay}</p>
        <a href={waLink("Halo, saya butuh bantuan terkait Mas Tofa AI.")} target="_blank" rel="noopener noreferrer" data-testid="help-whatsapp">
          <Button className="mt-3 bg-emerald-600 hover:bg-emerald-700"><MessageCircle className="mr-2 h-4 w-4" />Hubungi lewat WhatsApp</Button>
        </a>
        <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-1 text-sm">{POLICY_LINKS.map((l) => <li key={l.to}><Link to={l.to} className="text-blue-700 hover:underline">{l.label}</Link></li>)}</ul>
      </div>
    </PublicPage>
  );
}
